export default "__VITE_ASSET__H8IYs9Kz__"